'use client';
import type { ReactElement } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { IconMenu } from '@tabler/icons-react';
import { ButtonPreset } from '@/constants/componentPresets';
import { BackButton } from '../../common-buttons/BackButton';
import { Cbutton } from '../Cbutton';
interface LoggedNavbarLeftActionProps {
    isMobile: boolean;
    isSessionsModalOpen: boolean;
    onHamburgerClick: () => void;
    onModalClose: () => void;
}
interface HamburgerIconSizeInput {
    isMobile: boolean;
}
function getHamburgerIconSize({ isMobile, }: HamburgerIconSizeInput): number {
    return isMobile ? 21 : 28;
}
export function LoggedNavbarLeftAction({ isMobile, isSessionsModalOpen, onHamburgerClick, onModalClose, }: LoggedNavbarLeftActionProps): ReactElement {
    return (
      <AnimatePresence mode="wait" initial={false}>
        {isSessionsModalOpen ? (<motion.div key="back-button" initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} transition={{ duration: 0.1, ease: [0.4, 0, 0.2, 1] }}>
            <BackButton onClick={onModalClose}/>
          </motion.div>) : (<motion.div key="hamburger-button" initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} transition={{ duration: 0.1, ease: [0.4, 0, 0.2, 1] }}>
              <Cbutton icon={IconMenu} iconSize={getHamburgerIconSize({ isMobile })} preset={ButtonPreset.Ghost} onClick={onHamburgerClick}/>
            </motion.div>)}
      </AnimatePresence>
    );
}
